/**
 * API接口配置文件
 */
export default {

	common:{
		config:"index/getinfo", // 获取服务端配置
		notice:"ucenter/notice",
	}
}